export function InIFrame(): boolean {
  try {
    return window.location !== window.parent.location;
  } catch {
    return true;
  }
}
